import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { Actions } from '../actionTypes/actionTypes';
import { onDealsFetched } from '../deals/dealsActions';
import { setDealerLogo } from '../common/commonActions';

export const showroomNavMiddleware = (store: any) => (next: any) => (action: AnyFSA) => {
    next(action);
    const { payload } = action;

    switch (action.type) {
        case Actions.BOOTSTRAP_SUCCESS: {
            store.dispatch(setDealerLogo(payload?.dealerDetails?.dealerSettings?.dealerSettings?.dealerLogo));
            break;
        }
        case Actions.FETCH_DEALS_SUCCESS: {
            const dealCount = payload?.data?.deals?.length;
            if (dealCount > 0) store.dispatch(onDealsFetched(dealCount));
            break;
        }
    }
};
